import { forwardRef } from "react";
import type { ComponentPropsWithRef } from "react";
import { Hr } from "@react-email/components";
import { Section } from "@react-email/components";
import type { StyleValue } from "@/react/components/shared/BuilderUI/StyleValue.types";
import { useParseStyles } from "../../../Design/useParseStyles";
import { defaultStyles } from "./defaultStyles";

export interface LineProps extends ComponentPropsWithRef<"table"> {
  styles: Record<string, StyleValue>;
}

export const Line = forwardRef<HTMLTableElement, LineProps>(
  ({ styles, ...rest }, ref) => {
    const inlineStyles = useParseStyles({
      styles,
      defaultStyles,
    });

    const sectionStyles = {
      width: "100%",
    };

    return (
      <Section ref={ref} style={sectionStyles} {...rest}>
        <Hr style={inlineStyles} />
      </Section>
    );
  },
);

Line.displayName = "Line";
